interface ConnectWaveIconFilledProps {
  className?: string;
  color?: string;
  size?: "base" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const ConnectWaveIconFilled = ({
  className = "",
  color = "currentColor",
  size = "md",
}: ConnectWaveIconFilledProps) => {
  const sizeClasses = {
    base: "w-4 h-4",
    xs: "w-6 h-6",
    sm: "w-7 h-7",   // ~16x16px
    md: "w-8.5 h-8.5",   // ~24x24px
    lg: "w-9.5 h-9.5",   // ~32x32px
    xl: "w-11 h-11", // ~40x40px
  };
// Shared props for the stroked paths to keep code clean
  const strokeProps = {
    fill: "none",
    stroke: color,
    strokeWidth: "1.2",
    strokeLinecap: "round" as const,
    strokeMiterlimit: "10",
  };

  return (
    <div className="icon connect-wave-icon-filled">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-1.5 0 29.4 28.7"
        className={`${sizeClasses[size]} ${className}`}
        aria-hidden="true"
      >
        {/* Main Hand Shape (Previously .st1) */}
        <path
          d="M4.5,24.7c.9.8,3.1,2.6,5.8,2.9,2.7.3,4.4-1.9,4.4-1.9l5.5-5.6,3.4-3s1.9-1.7,1.2-2.5-2.6.6-2.6.6c0,0-1.8,1.5-2.1,1.8s-1.3,1.3-1.8.8.3-1.2.5-1.5,4.8-5.4,4.8-5.4c0,0,1.4-1.4.6-2.3-1.1-1.2-2.5.6-2.5.6-1.7,1.8-4.8,5.1-5,5.3s-.8.9-1.3.5,0-1,.3-1.3,4.8-6.2,4.8-6.2c0,0,1.8-2.2.6-3s-2.4.8-2.4.8c0,0-4.8,6.4-5,6.6s-.7,1.2-1.3.8,0-1.2.2-1.5,3.2-5.2,3.2-5.2c0,0,1.3-2,0-2.7s-2.3,1.4-2.3,1.4l-4.1,6.3-2.1,3.2s-.8,1.1-1,1,0-2.7-1.4-4.7-2.3-2.3-3.5-2-.2,1,0,2.2.3,2.9.2,3.8c-.2,1.5-.5,2.7-.5,3.4,0,1.4.3,2.8,1.1,4.2s2.2,2.6,2.2,2.6h0Z"
          fill={color}
          stroke={color}
          strokeWidth="0.4"
        />

        {/* Motion/Detail Lines (Previously .st0) */}
        <path
          d="M11,3.4s-1.2.8-2.2,2.3-1.4,3.6-1.4,3.6"
          {...strokeProps}
        />
        <path
          d="M10,1.3s-1.6.8-3.2,3-1.5,3.8-1.5,3.8"
          {...strokeProps}
        />
        <path
          d="M21.4,23.4s1.4-.4,2.8-1.7,2.2-3.1,2.2-3.1"
          {...strokeProps}
        />
        <path
          d="M21.9,25.7s1.7-.4,3.8-2.1,2.5-3.3,2.5-3.3"
          {...strokeProps}
        />
      </svg>
    </div>
  );
};

export default ConnectWaveIconFilled;